<template>
    <div class="SocState">
        <Title firstName="剩余电量" lastName="SOC-STATE OF CHARGE"/>
        <div class="echarts">
            <div class="edata">
                <div class="edataCon">
                    <p>剩余电量</p>
                    <p>{{hourPercent}}<span> %</span></p>
                </div>
                <div class="edataCon">
                    <p>配置容量</p>
                    <p>200<span> kWh</span></p>
                </div>
            </div>
            <div class="eview">
                <Graph :chartId="chartId" :seriesData="seriesData" :xData="xTime" v-if="seriesData.length > 0"/>
            </div>
            <div class="bottom"></div>
        </div>
    </div>
</template>

<script>
const Title = () => import('../../../components/title/Title.vue')
const Graph = () => import('../../../components/echarts/graph.vue')

export default {
    data(){
        return {
            chartId:'soc',
            seriesData:[]
        }
    },
    components:{
        Title,Graph
    },
    mounted(){
        this.getSoc()
    },
    methods:{
        getSoc(){
            let arr = [40, 80, 120, 160, 200, 200, 200, 200, 200, 200, 200, 200, 200, 200, 200, 200, 200, 200, 200, 200, 200, 120, 40, 40, 40 ]
            let hour = new Date().getHours() + 1
            this.seriesData = arr.splice(0,hour)
            console.log(hour);
        }
    },
    computed:{
        xTime(){
            let arr = []
            for(let i = 0;i<=24;i++){
                let one = i<10? '0'+i+':00':i+':00'
                arr.push(one)
            }
            return arr
        },
        hourPercent(){
            let now = this.seriesData[this.seriesData.length - 1] / 200 * 100
            return now
        }
    }
}
</script>

<style lang="less" scoped>
    .SocState{
        height: 33.3vh;
        width: 20vw;
        position: fixed;
        top: 30.3vh;
        left: 2vw;

        .echarts{
            position: relative;
            height: 28.7vh;
            padding-bottom: 1vh;
            background:  linear-gradient(0deg, rgba(0, 33, 59, 0.6) 0%, rgba(3, 13, 24, 0.7) 100%);

            .edata{
                height: 9vh;
                display: flex;
                justify-content: space-around;
                padding: 3vh 0;
                .edataCon{
                    text-align: center;
                    p:nth-child(1){
                        font-size: 14rem;
                        font-family: Source Han Sans CN;
                        font-weight: 400;
                        color: rgba(230,243,253, 0.7);
                    }
                    p:nth-child(2){
                        padding-top: 3rem;
                        font-size: 20rem;
                        font-family: zcoolqingkehuangyouti;
                        font-weight: 400;
                        color: #00DEFF;
                        span{
                            font-size: 14rem;
                        }
                    }
                }
            }

            .eview{
                width: 100%;
                padding: 0 0.5vw;
                height: 17.9vh;
                #socStateChart{
                    width: 100%;
                    height: 100%;
                }
            }

            .bottom{
                width: 20vw;
                height: 1vh;
                background: url(../../../assets/img/板块装饰线.png) no-repeat;
                block-size: 100% 100%;
                position: absolute;
                bottom: 0;
                left: 0;
            }
        }

        
    }

</style>